export const ANIMATION_SPEED = 200;
export const COLLAPSED_WIDTH = 68;
export const EXPANDED_WIDTH = 270;
export const MOBILE_HEIGHT_BREAKPOINT = '(min-height:650px)';
